import { render, staticRenderFns } from "./SelectOptionsNewFilter.vue?vue&type=template&id=24054e9a&scoped=true"
import script from "./SelectOptionsNewFilter.vue?vue&type=script&lang=js"
export * from "./SelectOptionsNewFilter.vue?vue&type=script&lang=js"
import style0 from "./SelectOptionsNewFilter.vue?vue&type=style&index=0&id=24054e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24054e9a",
  null
  
)

export default component.exports